import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { fee } from "../../rbac-consts";
import { default as AdminRangeFeeDetailsContainer } from "./admin/rangeFee/RangeFeeDetailsContainer";

const ClientsRangeFeeWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={fee.ADMIN}
      yes={() => (
        <AdminRangeFeeDetailsContainer match={match} />
      )}
    />
  );
};

export default ClientsRangeFeeWrapper;